import axios from "axios";
import { API } from "../common/Constants";

const accessToken = localStorage.getItem("dealerModuleToken");

export default axios.create({
    baseURL: API.BaseUrl,
    headers: {
        Authorization: `Bearer ${accessToken}`,
    },
})